<template>
    <ul
        v-editable="blok"
        class="company-info-list"
        aria-label="Company statistics"
    >
        <KCard
            v-for="{ icon, key, label, labelHighlight, value } in items"
            :key="key"
            as="li"
            variant="surface"
            padding="md"
            class="company-info-list__item"
        >
            <span
                class="company-info-list__item-icon-wrapper"
                aria-hidden="true"
            >
                <img
                    :src="icon"
                    class="company-info-list__item-icon"
                    alt=""
                >
            </span>

            <span class="company-info-list__item-content">
                <span
                    class="company-info-list__item-value"
                >
                    {{ value }}
                </span>
                <span class="company-info-list__item-label">
                    {{ label }} <span>{{ labelHighlight }}</span>
                </span>
            </span>
        </KCard>
    </ul>
</template>

<script setup>
import { KCard } from '@vemedia/karibu'
import { computed } from 'vue'
import './about-us-widget.scss'

const props = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
})

// This stays app-owned: the fixed Storyblok fields and brand icons make it a
// company metrics widget, not a reusable Karibu stat-list primitive.
const items = computed(() => [
    {
        key: 'visitors',
        icon: '/images/icons/visitors.svg',
        label: 'Monthly',
        labelHighlight: 'Visitors',
        value: props.blok.visitors,
    },
    {
        key: 'articles',
        icon: '/images/icons/articles.svg',
        label: 'Total',
        labelHighlight: 'Articles',
        value: props.blok.articles,
    },
    {
        key: 'team-size',
        icon: '/images/icons/team-size.svg',
        label: 'Team',
        labelHighlight: 'Size',
        value: props.blok.team_size,
    },
])
</script>
